"use client"; // Ensures the component runs on the client side

import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import imgPlaceholder from '../../assets/images/resources/img-placeholder.svg';
import { TEAM_IMAGE_POOL, pickPoolImage } from '../../utils/imagePools';
import { getTeam } from "../../services/settingsService";

const teamImg1 = "https://loremflickr.com/410/455/portrait,woman?lock=126";
const teamImg2 = "https://loremflickr.com/410/455/portrait,man?lock=127";
const teamImg3 = "https://loremflickr.com/410/455/portrait,woman?lock=128";

const fallbackMembers = [
  {
    id: 1,
    name: "Sarah Ahmed",
    role: "Event Coordinator",
    image: teamImg1,
    hoverText:
      "Events bring people together for shared experiences and celebrations. From weddings and birthdays to conferences and festivals, events create memories.",
    link: "/team-details",
  },
  {
    id: 2,
    name: "Karim Hasan",
    role: "Operations Lead",
    image: teamImg2,
    hoverText:
      "Events bring people together for shared experiences and celebrations. From weddings and birthdays to conferences and festivals, events create memories.",
    link: "/team-details",
  },
  {
    id: 3,
    name: "Nabila Rahman",
    role: "Content Creator",
    image: teamImg3,
    hoverText:
      "Events bring people together for shared experiences and celebrations. From weddings and birthdays to conferences and festivals, events create memories.",
    link: "/team-details",
  },
];

export default function TeamOne() {
  // State for dynamic content
  const [teamContent, setTeamContent] = useState({
    tagline: "Our Team Member",
    title: "Our Amazing & Learned Event Speakers",
    members: fallbackMembers,
  });

  useEffect(() => {
    getTeam()
      .then((data) => {
        if (data.items && data.items.length > 0) {
          setTeamContent((prev) => ({
            ...prev,
            members: data.items.slice(0, 3).map((m) => ({
              id: m.id, name: m.name, role: m.role, image: m.image,
              hoverText: m.bio || '', link: "/team-details",
            })),
          }));
        }
      })
      .catch(() => {});
  }, []);

  return (
    <>
      {/* Team One Start */}
      <section id="th-team" className="team-one">
        <div className="container">
          <div className="section-title text-center">
            <div className="section-title__tagline-box">
              <span className="section-title__tagline">{teamContent.tagline}</span>
            </div>
            <h2 className="section-title__title">
              {teamContent.title.split(" & ").map((text, index) => (
                <span key={index}>
                  {text}
                  <br />
                </span>
              ))}
            </h2>
          </div>
          <div className="row">
            {teamContent.members.map((member, index) => (
              <div
                key={member.id}
                className={`col-xl-4 col-lg-6 wow fadeIn${
                  index === 0 ? "Left" : index === 1 ? "Up" : "Right"
                }`}
                data-wow-delay={`${(index + 1) * 100}ms`}
              >
                <div className="team-one__single">
                  <div className="team-one__img-box">
                    <div className="team-one__img">
                      <img
                        src={member.image || pickPoolImage(TEAM_IMAGE_POOL, member.id ?? member.name) || imgPlaceholder}
                        alt={member.name}
                        onError={(e) => { e.target.onerror = null; e.target.src = imgPlaceholder; }}
                      />
                      <div className="team-one__content">
                        <h4 className="team-one__name">
                          <Link to={member.link}>{member.name}</Link>
                        </h4>
                        <p className="team-one__sub-title">{member.role}</p>
                      </div>
                      <div className="team-one__content-hover">
                        <h4 className="team-one__name-hover">
                          <Link to={member.link}>{member.name}</Link>
                        </h4>
                        <p className="team-one__sub-title-hover">{member.role}</p>
                        <p className="team-one__text-hover">{member.hoverText}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Team One End */}
    </>
  );
}
